import React, { useLayoutEffect, useState } from "react";
import { Button, Col, Modal, Row, Space } from "antd";
import { displayMessage, getAPI, stripHTML } from "../../../../utils/common";
import { ERROR_MSG_TYPE } from "../../../../constants/messages";
import { DYNAMIC_CONTENT_LIST, SETTING } from "../../../../constants/api";
import { Footer } from "antd/es/layout/layout";
import { CREATOR_LINK, CREATOR_NAME } from "../../../../constants/constent";
import {
  FacebookFilled,
  InstagramFilled,
  YoutubeFilled,
  TwitterSquareFilled,
} from "@ant-design/icons";
const FooterComponent = () => {
  const [loading, setLoading] = useState(false);
  const [socials, setSocial] = useState(null);
  const [pages, setPages] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);

  // Open the modal with the page description
  const openModal = (title, description) => {
    setModalContent(description);
    setModalTitle(title);
    setIsModalVisible(true);
  };

  // Handle social media button click
  const handleSocialClick = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  const getSetting = async () => {
    try {
      const successFn = (data) => {
        if (data.status === true) {
          const social = {
            instagram: data.data.instagram || null,
            youtube: data.data.youtube || null,
            twitter: data.data.tweeter || null,
            facebook: data.data.facebook || null,
          };
          setSocial(social);
        } else {
          setSocial(null);
          displayMessage(
            ERROR_MSG_TYPE,
            data.message || "Failed to load settings"
          );
        }
      };

      const errorFn = () => {
        setSocial(null);
        displayMessage(ERROR_MSG_TYPE, "Unable to get settings");
      };

      await getAPI(SETTING, successFn, errorFn);
    } catch (error) {
      displayMessage(
        ERROR_MSG_TYPE,
        "An error occurred while loading settings."
      );
    }
  };
  const getDynamicPages = () => {
    setLoading(true);

    const successFn = function (data) {
      if (data.status === true) {
        setPages(data["data"]);
        setLoading(false);
      } else {
        setPages([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setPages([]);
      setLoading(false);
    };
    getAPI(DYNAMIC_CONTENT_LIST, successFn, errorFn, {});
  };

  useLayoutEffect(() => {
    getSetting();
    getDynamicPages();
  }, []);

  return (
    <Footer className="footer" style={{ padding: "1rem" }}>
      <Row justify="space-between" align="middle" gutter={[16, 16]}>
        {/* Left side: Page links and creator */}
        <Col xs={24} sm={16} className="footer-col-1">
          <b>
            {pages.map((e, i) => (
              <span key={e.title}>
                <button
                  onClick={() => openModal(e.title, e.description)}
                  className="link-button"
                >
                  {e.title}
                </button>
                {i !== pages.length - 1 && <span> | </span>}
              </span>
            ))}
            <button
              key={CREATOR_NAME}
              onClick={() => handleSocialClick(CREATOR_LINK)}
              className="link-button"
              style={{ marginLeft: 8 }}
            >
              Powered by <b style={{ color: "orange" }}>{CREATOR_NAME}</b>
            </button>
          </b>
        </Col>

        {/* Right side: Social buttons */}
        <Col xs={24} sm={8} className="footer-col-2">
          <Space size="middle" wrap>
            <Button
              type="primary"
              shape="circle"
              icon={<FacebookFilled />}
              loading={loading}
              onClick={() => handleSocialClick(socials.facebook)}
            />
            <Button
              type="primary"
              shape="circle"
              icon={<InstagramFilled />}
              loading={loading}
              onClick={() => handleSocialClick(socials.instagram)}
            />
            <Button
              type="primary"
              shape="circle"
              icon={<YoutubeFilled />}
              loading={loading}
              onClick={() => handleSocialClick(socials.youtube)}
            />
            <Button
              type="primary"
              shape="circle"
              icon={<TwitterSquareFilled />}
              loading={loading}
              onClick={() => handleSocialClick(socials.twitter)}
            />
          </Space>
        </Col>
      </Row>

      {/* Modal for displaying page description */}
      <Modal
        title={modalTitle}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <div dangerouslySetInnerHTML={{ __html: modalContent }} />
      </Modal>
    </Footer>
  );
};

export default FooterComponent;
